import * as service from './service'
export default {
  namespace: 'widgetMallHome',
  state: {
    categoryList: {},
    zoneSalesList: {},
    getActivityData: ''
  },
  effects: {
    * getCategoryList ({ payload }, { call, put }) {
      const res = yield call(service.getCategoryList, payload)
      yield put({
        type: 'save',
        payload: {
          categoryList: res.data.data
        }
      })
      return res.data
    },
    * querySaleList ({ payload }, { call, put }) {
      const res = yield call(service.querySaleList, payload)
      yield put({
        type: 'save',
        payload: {
          saleList: res.data.data
        }
      })
      return res.data
    },
    * getActivityData ({ payload }, { call, put }) {
      const res = yield call(service.getActivityData, payload)
      yield put({
        type: 'save',
        payload: {
          getActivityData: res.data.data
        }
      })
      return res.data
    },
    * statsAd ({ payload }, { call, put }) {
      const res = yield call(service.statsAd, payload)
      yield put({
        type: 'save',
        payload: {
          statsAdData: res.data.data
        }
      })
      return res.data
    },
    * watchAction ({ payload }, { call, put }) {
      const res = yield call(service.watchAction, payload)
      yield put({
        type: 'save',
        payload: {
          pathData: res.data.data
        }
      })
      return res.data
    }
  },

  reducers: {
    save (state, { payload }) {
      return { ...state, ...payload }
    }
  }
}
